import { render, staticRenderFns } from "./Ueps.vue?vue&type=template&id=35cba19a&scoped=true"
import script from "./Ueps.vue?vue&type=script&lang=js"
export * from "./Ueps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cba19a",
  null
  
)

export default component.exports